export default {
	privacy: 'Politique de Confidentialité',
	beet: {
		credits: 'Site web conçu et développé par'
	},
	select: {
		field: 'Sélectionnez un domaine'
	},
	moreDetails: 'Plus de détails',
	noResults: 'Aucun résultat ne correspond à vos critères de recherche. Vous pouvez vous inscrire à nos alertes pour recevoir une notifications lorsqu\'un poste qui correspond ouvrira.'
}
